import axios from 'axios'

// Instância limpa: sem o header Authorization global (setado após o login em
// AuthOrApp.js), que dispara um preflight OPTIONS bloqueado pelo ViaCEP.
export default async function fetchViaCep(cep) {
  const viaCepClient = axios.create()
  delete viaCepClient.defaults.headers.common.Authorization

  const resp = await viaCepClient
    .get(`https://viacep.com.br/ws/${cep}/json/`)
    .then(response => response?.data)

  if (!resp || resp?.erro) return null

  return resp
}
